import React from 'react';
import { 
  MdDashboard, 
  MdBarChart, 
  MdDescription, 
  MdFolderShared, 
  MdPeople, 
  MdSettings, 
  MdHelpOutline,
  MdNotifications,
  MdMoreVert,
  MdMoreHoriz 
} from 'react-icons/md';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import './SafetyObservationActions.css';

const SafetyObservationActions = () => {

  // Data for Line Chart
  const lineChartData = [
    { name: 'Jul 2020', value: 750 },
    { name: 'Aug 2020', value: 510 },
    { name: 'Sep 2020', value: 740 },
    { name: 'Oct 2020', value: 600 },
    { name: 'Nov 2020', value: 610 },
    { name: 'Dec 2020', value: 670 },
    { name: 'Jan 2021', value: 580 },
    { name: 'Feb 2021', value: 430 },
    { name: 'Mar 2021', value: 380 },
    { name: 'Apr 2021', value: 550 },
    { name: 'May 2021', value: 350 },
  ];

  // Data for Stacked Bar Charts (Qtr)
  const stackedBarData = [
    { name: 'Qtr 1', scheduled: 23, nonScheduled: 21 },
    { name: 'Qtr 2', scheduled: 30, nonScheduled: 18 },
    { name: 'Qtr 3', scheduled: 32, nonScheduled: 18 },
    { name: 'Qtr 4', scheduled: 22, nonScheduled: 12 },
  ];

  // Data for Dense Bar Chart (Generated similar to the script)
    const denseBarData = Array.from({ length: 30 }, (_, i) => {
    const scheduled = Math.floor(Math.random() * 20) + 60;
    return {
      name: (i + 1).toString(),
      scheduled: scheduled,
      nonScheduled: 100 - scheduled
    };
  });

  return (

      <main className="so-main" style={{ height: '100%', overflow: 'auto' }}>
        <header className="so-content-header">
          <div>
            <h1 className="so-page-title">Dashboard Overview</h1>
            <p className="so-page-subtitle">Welcome back, here's what's happening today.</p>
          </div>
          <div className="so-header-actions">
            <button className="so-btn-icon">
              <MdNotifications size={24} />
            </button>
            <button className="so-btn-primary">
              Export Report
            </button>
          </div>
        </header>

        <div className="so-grid">
          {/* Card 1: Line Chart */}
          <div className="so-card">
            <div className="so-card-header">
              <h3 className="so-card-title">SO Trend Dolvi</h3>
              <div className="so-card-actions">
                <button className="so-action-btn">Week</button>
                <button className="so-action-btn active">Month</button>
                <button className="so-action-btn">Year</button>
                <MdMoreHoriz size={20} style={{ cursor: 'pointer', marginLeft: '0.25rem' }} />
              </div>
            </div>
            <div className="so-chart-container">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={lineChartData}>
                  <CartesianGrid vertical={false} stroke="#e5e7eb" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <Tooltip />
                  <Line 
                    type="linear" 
                    dataKey="value" 
                    stroke="#1d4ed8" 
                    strokeWidth={2} 
                    dot={{ r: 4, fill: '#fff', stroke: '#1d4ed8', strokeWidth: 2 }} 
                    name="Vijaynagar STL"
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Card 2: Stacked Bar Chart 1 */}
          <div className="so-card">
            <div className="so-card-header">
              <h3 className="so-card-title">SO Trend Dolvi</h3>
              <div className="so-card-actions">
                <button className="so-action-btn">Week</button>
                <button className="so-action-btn active">Month</button>
                <button className="so-action-btn">Year</button>
                <MdMoreHoriz size={20} style={{ cursor: 'pointer', marginLeft: '0.25rem' }} />
              </div>
            </div>
            <div className="so-chart-container">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={stackedBarData}>
                  <CartesianGrid vertical={false} stroke="#e5e7eb" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <Tooltip cursor={{ fill: 'transparent' }} />
                  <Bar dataKey="scheduled" stackId="a" fill="#ef4444" name="Scheduled tasks" />
                  <Bar dataKey="nonScheduled" stackId="a" fill="#1d4ed8" name="Non scheduled tasks" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

           {/* Card 3: Stacked Bar Chart 2 */}
           <div className="so-card">
            <div className="so-card-header">
              <h3 className="so-card-title">SO Trend Dolvi</h3>
              <div className="so-card-actions">
                <button className="so-action-btn">Week</button>
                <button className="so-action-btn active">Month</button>
                <button className="so-action-btn">Year</button>
                <MdMoreHoriz size={20} style={{ cursor: 'pointer', marginLeft: '0.25rem' }} />
              </div>
            </div>
            <div className="so-chart-container">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={stackedBarData}>
                  <CartesianGrid vertical={false} stroke="#e5e7eb" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <Tooltip cursor={{ fill: 'transparent' }} />
                  <Bar dataKey="scheduled" stackId="a" fill="#ef4444" name="Scheduled tasks" />
                  <Bar dataKey="nonScheduled" stackId="a" fill="#1d4ed8" name="Non scheduled tasks" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Card 4: Dense Bar Chart */}
          <div className="so-card">
            <div className="so-card-header">
              <h3 className="so-card-title">SO Trend Dolvi</h3>
              <div className="so-card-actions">
                <button className="so-action-btn">Week</button>
                <button className="so-action-btn active">Month</button>
                <button className="so-action-btn">Year</button>
                <MdMoreHoriz size={20} style={{ cursor: 'pointer', marginLeft: '0.25rem' }} />
              </div>
            </div>
            <div className="so-chart-container">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={denseBarData} barCategoryGap="10%">
                  <CartesianGrid vertical={false} stroke="#e5e7eb" />
                  <XAxis 
                    dataKey="name" 
                    axisLine={false} 
                    tickLine={false} 
                    tick={{ fill: '#6b7280', fontSize: 10 }}
                    interval={0}
                  />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#6b7280', fontSize: 12 }} />
                  <Tooltip cursor={{ fill: 'transparent' }} />
                  <Bar dataKey="scheduled" stackId="a" fill="#ef4444" name="Scheduled tasks" />
                  <Bar dataKey="nonScheduled" stackId="a" fill="#1d4ed8" name="Non scheduled tasks" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

        </div>
      </main>
  );
};

export default SafetyObservationActions;
